import { Button, Col, Modal, Row } from 'antd';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useState } from 'react';

function VMCVideo() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    // Handle "OK" button logic here
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    // Handle "Cancel" button logic here
  };

  return (
    <>
      <Row gutter={24}>
        <Col xs={24} sm={12} style={{ marginBottom: '24px' }}>
          <motion.div
            className="image-wrapper video-thumbnail"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <Image
              src="/images/brandymail-vmc-video-thumbnail.png"
              loading="eager"
              alt="Brandymail Is Trusted By 10,000+ Happy Users Around The World - Brandymail.com"
              className="image cover video-image"
              height={1220}
              width={650}
            />
            <Button className="video-btn w-inline-block" onClick={showModal}>
              <Image
                src="/images/icon-video-button-techkit-template.svg"
                loading="lazy"
                alt="Play video"
                className="video-btn-icon"
                height={100}
                width={100}
              />
            </Button>
            <div className="video-filter"></div>
          </motion.div>
        </Col>
        <Col xs={24} sm={12} className="video-content-col" style={{ paddingLeft: '32px' }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <div
              className="text-100 bold color-accent-1 text-uppercase"
              style={{ marginBottom: '20px' }}
            >
              DigiCert VMC Video
            </div>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            A Quick Look at Verified Mark Certificates: Why it Matters!
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <p className="paragraph-medium">
              Explore how VMC-driven, Logo-verified email strengthens user confidence, broadens
              brand visibility, enriches customer touchpoints, and intensifies user participation.
            </p>
            <Button type="primary" onClick={showModal}>
              Learn More
            </Button>
          </motion.div>
        </Col>
      </Row>
      <Modal
        title="DigiCert VMC Product Reveal"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width="80%"
      >
        <video width="100%" controls autoPlay muted>
          <source
            src="https://www.digicert.com/content/dam/digicert/videos/digicert-vmc-product-reveal.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </Modal>
    </>
  );
}

export default VMCVideo;
